import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC4nRQr5ZDe9YBqliGtDEsTQPDGvMIv6Ro",
  authDomain: "atomicmusic.com.au",
  projectId: "atomic-musicapp",
  storageBucket: "atomic-musicapp.firebasestorage.app",
  messagingSenderId: "724748955113",
  appId: "1:724748955113:web:c8501076f02b35f8faef78",
  measurementId: "G-XKMTRH08XH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
